import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";

import COMMON from "common";
import classNames from "common/class-names";
import capitalizeCharacter from "common/capitalize-character";

const AppStatus = (props) => {
	const red = useMemo(() => {
		switch (props.status) {
			case COMMON.STATUS_ID.EXPIRED:
			case COMMON.STATUS_ID.DELETED:
			case COMMON.STATUS_ID.INACTIVE:
			case COMMON.STATUS_ID.ON_LEAVE:
			case COMMON.STATUS_ID.REJECTED:
			case COMMON.STATUS_ID.RESIGNED:
			case COMMON.STATUS_ID.DISMISSAL:
			case COMMON.STATUS_ID.CANCELLED:
			case COMMON.STATUS_ID.TERMINATION:
			case COMMON.STATUS_ID.CONVERSATION_ENDED:
			case COMMON.STATUS_ID.OVERDUE:
			case COMMON.STATUS_ID.FAILED:
				return true;
			default:
				return false;
		}
	}, [props.status]);

	const green = useMemo(() => {
		switch (props.status) {
			case COMMON.STATUS_ID.ACTIVE:
			case COMMON.STATUS_ID.WORKING:
			case COMMON.STATUS_ID.APPROVED:
			case COMMON.STATUS_ID.ACCEPTED:
			case COMMON.STATUS_ID.PERMANENT:
			case COMMON.STATUS_ID.COMPLETED:
				return true;
			default:
				return false;
		}
	}, [props.status]);

	const yellow = useMemo(() => {
		switch (props.status) {
			case COMMON.STATUS_ID.INTERN:
			case COMMON.STATUS_ID.READY:
				return true;
			default:
				return false;
		}
	}, [props.status]);

	const blue = useMemo(() => {
		switch (props.status) {
			case COMMON.STATUS_ID.PENDING:
			case COMMON.STATUS_ID.PROBATION:
			case COMMON.STATUS_ID.UPCOMING:
			case COMMON.STATUS_ID.ACKNOWLEDGED:
			case COMMON.STATUS_ID.ASSIGNED:
			case COMMON.STATUS_ID.PENDING_MANAGER:
			case COMMON.STATUS_ID.PENDING_ADMIN:
				return true;
			default:
				return false;
		}
	}, [props.status]);

	const className = useMemo(() => {
		return classNames({ status: true, "status--green": green, "status--red": red, "status--blue": blue, "status--yellow": yellow });
	}, [red, green, blue, yellow]);

	const status = useMemo(() => {
		if (props.description) return props.description;

		const string = props.status || "";

		switch (string) {
			case COMMON.STATUS_ID.CONVERSATION_ENDED:
				return "Closed";
			case COMMON.STATUS_ID.PENDING_MANAGER:
				return "Pending Manager Approval";
			case COMMON.STATUS_ID.PENDING_ADMIN:
				return "Pending Admin Approval";
			default:
				return capitalizeCharacter(string.split("_").join(" "));
		}
	}, [props?.status, props?.description]);

	return (
		<div className="app-status">
			<div className={className}>
				<p className="status__text">{status || "-"}</p>
			</div>
		</div>
	);
};

export default memo(AppStatus);

AppStatus.propTypes = {
	status: PropTypes.string,
	description: PropTypes.string,
};
